import { render, staticRenderFns } from "./illegal_addoredit.vue?vue&type=template&id=63e76961&"
import script from "./illegal_addoredit.vue?vue&type=script&lang=js&"
export * from "./illegal_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports